var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelBw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "256.000000pt",
    height: "256.000000pt",
    viewBox: "0 0 256.000000 256.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,256.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1000 2460 c-250 -49 -575 -112 -722 -141 l-268 -52 0 -993 c0 -547 3 -994 7 -994 4 0 323 -61 709 -135 386 -74 711 -135 723 -135 l21 0 0 1270 c0 699 -3 1270 -7 1269 -5 0 -213 -40 -463 -89z m-349 -840 c38 -80 76 -162 84 -183 l16 -39 85 169 c47 92 91 176 99 186 11 15 27 17 133 15 l121 -3 -146 -243 -146 -242 150 -250 151 -250 -133 0 -133 0 -94 188 -95 187 -95 -185 -94 -185 -132 -3 c-73 -1 -132 0 -132 3 0 3 68 112 151 242 82 130 151 239 152 243 2 5 -86 159 -266 468 l-19 33 137 -3 138 -3 68 -145z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1575 2248 c-3 -8 -4 -75 -3 -149 l3 -134 148 -3 147 -3 0 -99 0 -100 -150 0 -150 0 0 -95 0 -95 150 0 150 0 0 -95 0 -94 -147 -3 -148 -3 -3 -97 -3 -97 148 -3 148 -3 3 -97 3 -98 -151 0 -150 0 0 -95 0 -95 150 0 150 0 0 -100 0 -99 -147 -3 -148 -3 0 -145 0 -145 462 0 462 1 26 24 25 23 0 932 0 932 -26 24 -26 24 -459 4 c-387 3 -460 1 -464 -11z m785 -382 l0 -93 -61 -7 c-34 -3 -122 -6 -195 -6 l-134 0 0 100 0 100 195 0 195 0 0 -94z m0 -391 l0 -95 -195 0 -195 0 0 95 0 95 195 0 195 0 0 -95z m0 -395 l0 -100 -195 0 -195 0 0 100 0 100 195 0 195 0 0 -100z m-2 -392 l3 -98 -196 0 -195 0 0 100 0 100 193 -2 192 -3 3 -97z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelBw);
export default __webpack_public_path__ + "static/media/excel_bw.2bc3b8bfa58aa6fee67fb4e27dd3a24d.svg";
export { ForwardRef as ReactComponent };